import { render, staticRenderFns } from "./AssignmentCard.vue?vue&type=template&id=585a5fcd&scoped=true&"
import script from "./AssignmentCard.vue?vue&type=script&lang=js&"
export * from "./AssignmentCard.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCard.vue?vue&type=style&index=0&id=585a5fcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a5fcd",
  null
  
)

export default component.exports